import "./index.scss";

type Props = {
  headers: string[];
};

const TableHeader = ({headers}: Props) => {
  return (
    <thead id="custom-table-header">
      <tr>
        {headers.map((header: string, index: number) => (
          <td key={`th-${index}`}>{header}</td>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
